import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { SnConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { LoadingMessageDialogComponent } from './components/loading-message-dialog/loading-message-dialog.component';
import { FsInputDialogComponent } from './components/name-dialog/name-dialog.component';
import { TimeoutDialogComponent } from './components/timeout-dialog/timeout-dialog.component';
import { VideoDialogComponent } from './components/video-dialog/video-dialog.component';
import { SnDialogService } from './services/dialogs.service';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    SnCommonModule,
    // Material
    MatDialogModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatInputModule,
    MatButtonModule,
    // Libs
    SnIconModule,
    SnButtonModule,
    SnFormModule,
    TranslationModule,
  ],
  exports: [
    // Material
    MatDialogModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    InfoDialogComponent,
    SnConfirmDialogComponent,
    VideoDialogComponent,
    LoadingMessageDialogComponent,
    FsInputDialogComponent,
    TimeoutDialogComponent,
  ],
  declarations: [
    InfoDialogComponent,
    SnConfirmDialogComponent,
    VideoDialogComponent,
    LoadingMessageDialogComponent,
    FsInputDialogComponent,
    TimeoutDialogComponent,
  ],
})
export class SnDialogModule {
  public static forRoot(): ModuleWithProviders<SnDialogModule> {
    return {
      ngModule: SnDialogModule,
      providers: [SnDialogService],
    };
  }
}
